import {
  NotificationType,
  ParameterStructures,
  RequestType,
} from 'vscode-languageserver-protocol/browser';

const RequestCompositionRequestType = new RequestType<
  unknown,
  { didCompose: boolean },
  unknown
>('apollo/composeServices', ParameterStructures.byName);
export const RequestCompositionRequest = {
  method: RequestCompositionRequestType.method,
  type: RequestCompositionRequestType,
};

const ConfigureAutoCompositionType = new NotificationType<{
  enabled: boolean;
}>('apollo/configureAutoComposition');
export const ConfigureAutoComposition = {
  method: ConfigureAutoCompositionType.method,
  type: ConfigureAutoCompositionType,
};

const CanComposeNotificationType = new NotificationType<{
  canCompose: boolean;
  subgraphsWithErrors: string[];
}>('apollo/canCompose');
export const CanComposeNotification = {
  method: CanComposeNotificationType.method,
  type: CanComposeNotificationType,
};
